import { render, staticRenderFns } from "./MapLegend.vue?vue&type=template&id=7c85f676&scoped=true&"
import script from "./MapLegend.vue?vue&type=script&lang=js&"
export * from "./MapLegend.vue?vue&type=script&lang=js&"
import style0 from "./MapLegend.vue?vue&type=style&index=0&id=7c85f676&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c85f676",
  null
  
)

export default component.exports